import { LOCALE_ID, NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientJsonpModule, HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
/* 佈署用
// import { HashLocationStrategy , LocationStrategy } from '@angular/common';
// kendo
*/
// Load the required calendar data for the locale
// app
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
// his
import { HttpErrorInterceptor } from './shared/module/http/http-error.interceptor';
import { BaseConfig, initializeBaseConfig } from './services/base-config.service';
// Apply Material UI use
import { MatPaginatorIntl } from '@angular/material/paginator';
import { VisMatPaginatorIntl } from './shared/components/grid/visMatPaginatorIntl';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { LayoutModule } from './layout/layout.module';
import { UserRoleFunctionService } from './services/data-service/user-role-function.service';


const globalRippleConfig: RippleGlobalOptions = {
  disabled: true
};

import { ErrorHandler, Injectable } from '@angular/core';
import { DebugNotifyService } from './services/debug-notify.service';
import { EasyNotificationService } from './services/easy-notification.service';
import { UserConfirmService } from './services/user-confirm.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  /**
   *
   */
  constructor(
    private injector: Injector) {


  }
  handleError(error: any): void {
    // 可以送出 log、顯示通知、回報伺服器
    try{
      var debugApi:DebugNotifyService = this.injector.get(DebugNotifyService);
      var notify = this.injector.get(EasyNotificationService);
      if (error instanceof Error) {
        var e = {message:error.message,stack:error.stack}
        debugApi.Notify(JSON.stringify(e));
        if(BaseConfig.isDebug()){
          notify.showError('發生未處理的錯誤。',false,()=>{
            // if debug
            var ezConfirm = this.injector.get(UserConfirmService);
            ezConfirm.showAlert('詳細資料',`Message:\n${e.message}\n\nStack:\n${e.stack}`,{
              width:600
            })
          })
        }
      }else if (typeof error === 'string') {
        debugApi.Notify(error);
        if(BaseConfig.isDebug()){
          notify.showError('發生未處理的錯誤。',false,()=>{
            // if debug
            var ezConfirm = this.injector.get(UserConfirmService);
            ezConfirm.showAlert('詳細資料',`${error}`,{
              width:600
            })
          })
        }
      }

    }catch{}
    // 自訂處理邏輯，例如彈窗通知使用者
  }
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'cloud-clinics' }),
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    LayoutModule,
    // his
    // app routing總是放在最後一個import
    AppRoutingModule,
  ],
  exports: [

],
  providers: [HttpClientModule, HttpClient,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    BaseConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeBaseConfig,
      deps: [BaseConfig], multi: true
    },
    {provide: LOCALE_ID, useValue: 'zh-Hant'},
    { provide: MatPaginatorIntl, useClass: VisMatPaginatorIntl},
    {provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig},
    // { provide: ErrorHandler, useClass: GlobalErrorHandler },
    UserRoleFunctionService
    // {provide: LOCALE_ID, useValue: 'en-US'},
    // {provide: LOCALE_ID, useValue: 'zh-Hant'},
    // 佈署用
    // { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }

